import styled from 'styled-components';

export default styled.section`
  flex: 1;
  overflow-y: auto;
`;
